<div>
  <span>Select number of days to remind for comments </span>
  <select [(ngModel)]="selectedDays">
    <option *ngFor="let item of dropdownData" [value]="item.days">
      ({{ item.days }} days)
    </option>
  </select>
  <button mat-raised-button color="primary"(click)="onSave()">Save</button>
</div>


